// @flow

import React, { Component } from 'react';
import FlatButton from 'material-ui/FlatButton';
import Alert from 'react-s-alert';
// import _ from 'lodash';

import type { Element } from 'react';

import App from './App.jsx';
import DialogUser from './DialogUser.jsx';

import {no_rclick, noop} from './utils.js';
import {fetch_user_details} from './fetch_things.js';
import {remote_save} from './save_my_account.js';
import Role, {WebGoddess} from './roles.js';
import {bad_min_user, user_is_changed} from './types.js';

import type {T_User, T_UserMin, T_PredUserMin, T_ErrOk} from './types.js';

import './css/SelectUser.css';

const alertify = require('alertifyjs');


type T_SelectUserProps = {
  app   : App,
  width : number,
  height: number,
  users : Array<T_UserMin>
};


type T_SelectUserState = {
  the_user      : ?T_User,
  filtered_users: Array<T_UserMin>,
  search_name   : string,
  search_role   : string,
  search_dir    : string,
  search_bad    : boolean,
  top           : number,
  left          : number
};



export default class SelectUser extends Component<T_SelectUserProps, T_SelectUserState> {
  dialog_user: ?DialogUser;
  
  change_user   : (value: Object) => void;
  save_user     : (user: ?T_User) => void;
  remove_user   : (user_name: string) => void;
  change_name   : (ev: SyntheticInputEvent<*>) => void;
  change_dir    : (ev: SyntheticInputEvent<*>) => void;
  change_role   : (ev: SyntheticInputEvent<*>) => void;
  change_user   : (ev: SyntheticInputEvent<*>) => void;
  close         : () => void;
  filter_by_name: () => T_PredUserMin;
  filter_by_role: () => T_PredUserMin;
  filter_by_dir : () => T_PredUserMin;
  
  
  constructor(props: T_SelectUserProps) {
    super(props);
    
    this.state = {
      the_user      : null,
      filtered_users: this.props.users,
      search_name   : '',
      search_role   : '',
      search_dir    : '',
      search_bad    : false,
      top           : 100,
      left          : 100
    };
    
    this.save_user      = this.save_user.bind(this);
    this.remove_user    = this.remove_user.bind(this);
    this.change_name    = this.change_name.bind(this);
    this.change_dir     = this.change_dir.bind(this);
    this.change_role    = this.change_role.bind(this);
    this.change_user    = this.change_user.bind(this);
    this.filter_by_name = this.filter_by_name.bind(this);
    this.filter_by_role = this.filter_by_role.bind(this);
    this.filter_by_dir  = this.filter_by_dir.bind(this);
    this.close          = this.close.bind(this);
  }
  
  
  
  componentDidMount() {
    this.props.app.select_user = this;
    
    this.set_position();
  }
  
  
  
  componentWillUnmount() {
    this.props.app.select_user = null;
  }
  
  
  
  componentDidUpdate(prevProps: T_SelectUserProps, prevState: T_SelectUserState) {
    if (this.props.height !== prevProps.height || this.props.width !== prevProps.width) {
      this.set_position();
    }
    
    if (this.state.search_name !== prevState.search_name || this.state.search_dir !== prevState.search_dir || this.state.search_role !== prevState.search_role || this.state.search_bad !== prevState.search_bad) {
      this.set_filtered_users();
    }
    
    if (this.props.users.length !== prevProps.users.length) {
      this.setState({filtered_users: this.props.users});
    }
  }
  
  
  
  close(): void {
    this.props.app.setState({edit_users: []});
  }
  
  
  
  set_position(): void {
    this.setState({
      top : Math.max((this.props.height / 2) - 400, 50),
      left:          (this.props.width  / 2) - 300,
    });
  }
  
  
  
  filter_by_name(): T_PredUserMin {
    return (
      this.state.search_name !== '' ?
        user => user.user_name.indexOf(this.state.search_name.replace(/ /g, '.')) !== -1
      :
        user => true
    );
  }
  
  
  
  filter_bad(): T_PredUserMin {
    return (
      this.state.search_bad ?
        bad_min_user
      :
        user => true
    );
  }
  
  
  
  filter_by_role(): T_PredUserMin {
    return (
      this.state.search_role !== '' && ! this.state.search_bad ?
        user => user.role === this.state.search_role
      :
        user => true
    );
  }
  
  
  
  filter_by_dir(): T_PredUserMin {
    return (
      this.state.search_dir !== '' ?
        user => user.true_dirs.find(tdir => tdir.indexOf(this.state.search_dir.replace(/ /g, '_')) !== -1) != null
      :
        user => true
    );
  }
  
  
  
  set_filtered_users(): void {
    const f1 = this.filter_by_name(),
          f2 = this.filter_by_role(),
          f3 = this.filter_by_dir(),
          f4 = this.filter_bad();
    
    this.setState({
      filtered_users: this.props.users.filter(user => f1(user) && f2(user) && f3(user) && f4(user))
    });
  }
  
  
  
  change_name(ev: SyntheticInputEvent<*>): void {
    this.setState({search_name: ev.target.value});
  }
  
  
  
  change_dir(ev: SyntheticInputEvent<*>): void {
    this.setState({search_dir: ev.target.value});
  }
  
  
  
  change_role(ev: SyntheticInputEvent<*>): void {
    this.setState({
      search_role: (Role.known.indexOf(ev.target.value) !== -1 ? ev.target.value : ''),
      search_bad : ev.target.value === 'Incorrecto'
    });
  }
  
  
  
  change_user(ev: SyntheticInputEvent<*>): void {
    ev.persist();
    
    if ((! this.state.the_user) || this.state.the_user.user_name !== ev.target.value) {
      fetch_user_details(this.props.app, ev.target.value, (mb_user: T_User | string) => {
        if (typeof mb_user === 'string') {
          Alert.error(mb_user);
        }
        else {
          const the_user = (mb_user : T_User);
          
          this.setState({the_user: null}, () => {
            this.setState({the_user});
          });
        }
      });
    }
  }
  
  
  
  save_user(user: ?T_User): void {
    if (user != null) {
      if (this.state.the_user != null && user_is_changed(this.state.the_user, user)) {
        remote_save(this.props.app, user, false, (result: T_ErrOk) => {
          if (result.error && typeof result.error === 'string') {
            Alert.error(result.error);
          }
          else {
            this.setState({the_user: null}, () => {
              this.props.app.set_edit_users();
            });
          }
        });
      }
      else {
        this.setState({the_user: null});    // el usuario no se modificó. Cerrar dialog_user.
      }
    }
    else if (this.dialog_user != null) {
      this.dialog_user.set_errors();
    }
  }
  
  
  
  remove_user(user_name: string): void {
    alertify.confirm('Borrar', `¿Desea eliminar el usuario ${user_name}?`, () => {
      const {app} = this.props,
            url   = `${app.remote}/remove-user/?session_id=${app.session()}&other=${user_name}`;
      
      fetch(url).then(resp => resp.json()).then((response: T_ErrOk) => {
        if (response.error && typeof response === 'string') {
          Alert.error(response.error);
        }
        else {
          this.setState({the_user: null}, () => {
            app.set_edit_users();   // esto actualiza app.state.edit_users lo que actualiza this.props.users lo que gatilla this.componentDidUpdate lo que actualiza this.state.filtered_users
            
            Alert.success(`${user_name} fue eliminado exitosamente.`);
          });
        }
      });
    }, noop);
  }
  
  
  
  render_filters(): Element<string> {
    return (
      <table>
        <tbody>
          <tr>
            <td>Nombre:</td>
            <td>
              <input type='text' placeholder='Buscar…' value={this.state.search_name} onChange={this.change_name} />
            </td>
          </tr>
          
          <tr>
            <td>Carpeta:</td>
            <td>
              <input type='text' placeholder='Buscar…' value={this.state.search_dir} onChange={this.change_dir} />
            </td>
          </tr>
          
          <tr>
            <td>Rol:</td>
            <td>
              <select name='roles' onChange={this.change_role}>
                <option value='Escoja un rol'>Cualquiera</option>
                
                {Role.known.filter(role => role !== WebGoddess).map((role, num) => {
                  return (
                    <option key={num} value={role}>
                      {Role.friendly_name(role)}
                    </option>
                  );
                })}
                
                <option value='Incorrecto'>Incorrecto</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
  
  
  
  render() {
    const {app} = this.props;
    
    return (
      <div className='SelectUser' style={{top: this.state.top, left: this.state.left}}>
        <span>Buscar usuario</span>
        
        <table>
          <tbody>
            <tr>
              <td>
                <div className='selu_filters'>
                  {this.render_filters()}
                </div>
                
                {(this.state.filtered_users.length > 0) &&
                  <select name='filtered_users' size={10} onClick={this.change_user} onChange={this.change_user}>
                    {this.state.filtered_users.map((user, num) => {
                      return (
                        <option key={num} value={user.user_name}>
                          {user.user_name}
                        </option>
                      );
                    })}
                  </select>
                }
                
                {(this.state.filtered_users.length === 0) &&
                  <span className='selu_no_res'>
                    Sin resultados
                  </span>
                }
              </td>
              
              <td>
                {(this.state.the_user != null) &&
                  <DialogUser
                    app={app}
                    father_select={this}
                    window_drag={false}
                    show_titles={! app.dev_mode}
                    width={this.props.width}
                    height={this.props.height}
                    create_mode={false}
                    edit_dirs={true}
                    edit_roles={true}
                    only_edit_dirs={false}
                    the_user={this.state.the_user}
                    proceed={this.save_user}
                    remove_user={this.remove_user}
                    top={0}
                    left={230}
                  />
                }
              </td>
            </tr>
            
            <tr>
              <td>
                <div className='selu_close'>
                  <FlatButton
                    label='Cerrar'
                    primary={true}
                    onContextMenu={no_rclick}
                    onClick={this.close}
                    style={{marginRight: 10}}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/SelectUser.jsx